<template>
  <!-- - Agregar una opción para copiar liquidación -->
  <Styles>
    <section id="store_container">
      <fieldset class="fieldset">
        <legend>Datos liquidación</legend>
        <div class="liquidation-data">
          <div class="columns">
            <div class="column">
              <CompanySelector v-model="company"
                               v-validate="'required'"
                               placeholder="Seleccione una empresa"
                               name="company"/>
              <span class="show-error">{{ errors.first("company") }}</span>
            </div>
            <div class="column">
              <b-field label="Nombre *">
                <b-input
                    placeholder="Nombre"
                    type="text"
                    name="name"
                    v-model="name"
                    v-validate="'required'">
                </b-input>
              </b-field>
              <span class="show-error">{{ errors.first("name") }}</span>
            </div>
          </div>
          <div class="columns">
            <div class="column is-4">
              <b-field label="Principal *">
                <b-select
                    placeholder="Seleccione si es sucursal principal..."
                    expanded
                    v-model="principal"
                    name="principal"
                    v-validate="'required'">
                  <option
                      v-for="option in types"
                      :value="option.code"
                      :key="option.code"
                      :id="option.code">
                    {{ option.title }}
                  </option>
                </b-select>
              </b-field>
              <span class="show-error">{{ errors.first("principal") }}</span>
            </div>
            <div class="column is-4">
              <b-field label="Modalidad *">
                <b-select
                    placeholder="Modalidad"
                    expanded
                    v-model="mode"
                    v-validate="'required'"
                    name="mode">
                  <option
                      v-for="option in modeList"
                      :value="option.code"
                      :key="option.code"
                      :id="option.code">
                    {{ option.description }}
                  </option>
                </b-select>
              </b-field>
              <span class="show-error">{{ errors.first("mode") }}</span>
            </div>
            <div class="column is-4">
              <b-field label="Tipo de Vehículo *">
                <b-select
                    placeholder="Seleccione el tipo de vehículo..."
                    expanded
                    v-model="vehicleType"
                    name="vehicleType"
                    v-validate="'required'">
                  <option
                      v-for="option in vehicleTypes"
                      :value="option.code"
                      :key="option.code"
                      :id="option.code">
                    {{ option.title }}
                  </option>
                </b-select>
              </b-field>
              <span class="show-error">{{ errors.first("vehicleType") }}</span>
            </div>
          </div>
        </div>
        <fieldset class="fieldset mt-5" v-if="concepts.length > 0">
          <legend>Conceptos liquidación</legend>
          <div class="concepts-list">
            <div class="columns">
              <div class="column is-4">
                <b-field label="Conceptos">
                  <b-select
                      placeholder="Seleccione un concepto..."
                      expanded
                      v-model="concept"
                      name="concept">
                    <option
                        v-for="option in concepts"
                        :value="option.code"
                        :key="option.code"
                        :id="option.code">
                      {{ option.title }}
                    </option>
                  </b-select>
                </b-field>
              </div>
              <div class="column is-4">
                <vs-button
                    color="primary"
                    icon="add"
                    type="filled"
                    class="pl-4 pr-4 mt-button"
                    @click="addConcept">
                  Agregar
                </vs-button>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <b-table
                    :data="getAssociatedConcepts()"
                    :selected.sync="selected"
                    focusable
                    :paginated="true"
                    :per-page="5"
                    :bordered="true"
                    :current-page.sync="currentPage">
                  <b-table-column field="ID" label="ID" v-slot="props">
                    {{ props.row.index }}
                  </b-table-column>
                  <b-table-column
                      field="Concepto"
                      label="Concepto"
                      v-slot="props">
                    {{ props.row.concept.title }}
                  </b-table-column>
                  <b-table-column field="Valor" label="Valor" v-slot="props">
                    <b-field>
                      <b-input
                          v-if="props.row.concept.percent === 'Y'"
                          placeholder="Porcentaje (0-100)"
                          type="number"
                          name="value"
                          v-model="props.row.value"
                          v-mask="'###'"/>
                      <b-input
                          v-if="props.row.concept.percent !== 'Y'"
                          placeholder="Valor"
                          type="number"
                          name="value"
                          v-model="props.row.value"
                      />
                    </b-field>
                  </b-table-column>
                  <b-table-column
                      field="runtimeType"
                      label="Tipo ejecución"
                      v-slot="props">
                    <b-field>
                      <b-select
                          placeholder="Tipo ejecución"
                          expanded
                          v-model="props.row.runtimeType"
                          name="runtimeType">
                        <option value="N">No aplica</option>
                        <option value="F">Función</option>
                        <option value="T">Tarifa</option>
                      </b-select>
                    </b-field>
                  </b-table-column>
                  <b-table-column
                      field="value"
                      label="Selección - Valor"
                      v-slot="props">
                    <span v-if="props.row.runtimeType == 'N'">No aplica</span>
                    <div v-if="props.row.runtimeType == 'T'">
                      <b-field>
                        <b-select
                            placeholder="Seleccione una tarifa"
                            expanded
                            v-model="props.row.tariff"
                            name="tariff">
                          <option
                              v-for="option in tariffList"
                              :value="option.code"
                              :key="option.code"
                              :id="option.code">
                            {{ option.title }}
                          </option>
                        </b-select>
                      </b-field>
                    </div>
                    <b-field v-if="props.row.runtimeType == 'F'">
                      <b-select
                          placeholder="Ejecutar"
                          expanded
                          v-model="props.row.function"
                          name="name">
                        <option
                            v-for="option in functionsList"
                            :value="option.code"
                            :key="option.code"
                            :id="option.code">
                          {{ option.title }}
                        </option>
                      </b-select>
                    </b-field>
                  </b-table-column>
                  <b-table-column
                      field="actions"
                      label="Acciones"
                      v-slot="props">
                    <b-field>
                      <b-button
                          type="is-danger"
                          title="Eliminar"
                          @click="deleteConcept(props.row)"
                          icon-right="delete"/>
                    </b-field>
                  </b-table-column>
                  <template #bottom-left></template>
                  <template #empty>
                    <div class="has-text-centered">Sin registros</div>
                  </template>
                </b-table>
              </div>
            </div>
          </div>
        </fieldset>
      </fieldset>
      <div class="buttons button-group">
        <vs-button
            @click="save()"
            color="primary"
            type="filled"
            icon="save"
            class="pl-4 pr-4">
          Guardar
        </vs-button>
        <vs-button
            color="danger"
            type="filled"
            icon="delete"
            class="pl-4 pr-4 ml-3"
            v-if="actualCode">
          Eliminar
        </vs-button>
      </div>
      <b-loading :is-full-page="true" v-model="isLoading"></b-loading>
    </section>
  </Styles>
</template>

<script>
import {ROUTES} from "@/global/api_routes";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import {confirmation, getUrlParameters} from "@/global/utils";
import {get as getProp} from "object-path";
import CompanySelector from "@/components/Shared/CompanySelector";
import Styles from "./styles";

export default {
  name: "Concepts",
  components: {Styles, CompanySelector},
  data: () => ({
    id: null,
    associatedConcepts: [],
    actualCode: null,
    company: null,
    name: null,
    principal: null,
    vehicleType: null,
    concept: null,
    selected: null,
    isLoading: false,
    currentPage: 1,
    companies: [],
    vehicleTypes: [],
    functionsList: [],
    concepts: [],
    tariffList: [],
    mode: null,
    modeList: [],
    types: [
      {title: "Si", code: "Y"},
      {title: "No", code: "N"},
    ],
  }),
  mounted() {
    this.getCompanies();
    this.getVehicleTypes();
    this.getFunctions();
    this.checkEdition();
    this.getModeList();
  },
  watch: {
    company: function () {
      if (this.company) {
        this.getConcepts();
        this.getTariffList();
      }
    }
  },
  methods: {

    fillData(data) {
      this.company = getProp(data, "company.code");
      this.name = data.title;
      this.principal = getProp(data, "main", "N");
      this.mode = getProp(data, 'initials');
      this.vehicleType = getProp(data, "vehicleType.code");
      this.findRelated(data.code);
    },
    getModeList() {
      this.$http
          .get(ROUTES.DASHBOARD.LIQUIDATIONS.GET_MODES)
          .then(({data}) => {
            if (data.code) {
              this.modeList = data.info;
            }
          });
    },
    findRelated(liquidationCode) {
      this.isLoading = true;
      this.$http
          .get(ROUTES.DASHBOARD.LIQUIDATIONS.GET_RELATEDS, {
            params: {
              liquidationCode,
            },
          })
          .then(({data}) => {
            if (data.code > 0) {
              this.associatedConcepts = data.info.map((item, index) => {
                return {
                  index: index + 1,
                  ...item.concept,
                  ...item,
                  tariff: getProp(item, "tariff.code", null),
                  function: getProp(item, "function.code", null),
                  code: getProp(item, "code", null),
                };
              });
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    checkEdition() {
      const liquidationCode = getUrlParameters().code;
      if (!liquidationCode) {
        return;
      }
      this.actualCode = liquidationCode;
      this.isLoading = true;
      this.$http
          .get(ROUTES.DASHBOARD.LIQUIDATIONS.FIND_BY_ID, {
            params: {
              liquidationCode: liquidationCode,
            },
          })
          .then(({data}) => {
            if (data.code > 0) {
              this.fillData(data.info);
              return;
            }
            this.$toastInfo("No se encontró el registro.");
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    getAssociatedConcepts() {
      return this.associatedConcepts.filter((item) => !item.deleted);
    },
    addConcept() {
      const exist = this.associatedConcepts.find(
          (item) => getProp(item, "concept.code", null) === this.concept
      );
      if (exist) {
        this.$toastError("El concepto ya ha sido agregado.");
        return;
      }
      const concept = this.concepts.find((item) => item.code === this.concept);
      if (concept == null) {
        this.$toastError("Selecciona un concepto");
        return;
      }
      this.associatedConcepts.push({
        concept: concept,
        index: this.associatedConcepts.length + 1,
      });
    },
    deleteConcept(row) {
      confirmation(this, "¿Desea eliminar el registro?").then((result) => {
        if (!result) {
          return;
        }
        this.associatedConcepts = this.associatedConcepts.map((item) => ({
          ...item,
          deleted: item.concept.code === row.concept.code || item.deleted,
        }));
      });
    },
    validateConcepts() {
      if (!this.associatedConcepts || this.associatedConcepts.length === 0) {
        this.$toastInfo("Debes asociar al menos un concepto");
        return false;
      }
      return true;
    },
    getObj() {
      return {
        code: this.actualCode,
        title: this.name,
        initials: this.mode,
        main: this.principal,
        company: {code: this.company},
        vehicleType: {code: this.vehicleType},
        relatedList: this.associatedConcepts
            .filter(item => item.concept)
            .map((item, index) => {
              const obj = {
                code: item.code,
                concept: item.concept,
                runtimeType: item.runtimeType,
                value: item.value,
              };
              if (item.runtimeType === "F") {
                obj.function = {code: item.function};
              } else if (item.runtimeType === "T") {
                obj.tariff = {code: item.tariff};
              } else {
                obj.runtimeType = 'N';
              }
              if (item.deleted) {
                obj.status = "D";
              }
              obj.orderAt = index + 1;
              return obj;
            }),
      };
    },
    cleanForm() {
      this.company = null;
      this.name = null;
      this.principal = null;
      this.vehicleType = null;
      this.associatedConcepts = [];
      this.actualCode = null;
      this.$validator.reset();
    },
    save() {
      this.$validator.validateAll().then((result) => {
        if (!result || !this.validateConcepts()) {
          return;
        }
        this.isLoading = true;
        this.$http
            .post(ROUTES.DASHBOARD.LIQUIDATIONS.SAVE, this.getObj())
            .then(({data}) => {
              if (data.code > 0) {
                this.cleanForm();
                this.$toastOk("Se ha guardado correctamente el registro");
                return;
              }
              this.$toastError(data.message);
            })
            .finally(() => {
              this.isLoading = false;
            });
      });
    },
    getConcepts() {
      if (!this.company) {
        return;
      }
      this.isLoading = true;
      this.$http
          .get(ROUTES.DASHBOARD.CONCEPTS.LIST_BY_COMPANY, {
            params: {
              companyId: this.company,
            }
          })
          .then(({data}) => {
            if (data.code > 0) {
              this.concepts = data.info;
              return;
            }
            this.$toastError(data.code === 0 ? "Debes crear conceptos" : data.message);
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    getFunctions() {
      this.$http
          .get(ROUTES.DASHBOARD.LIQUIDATIONS.GET_FUNCTIONS)
          .then(({data}) => {
            if (data.code > 0) {
              this.functionsList = data.info;
              return;
            }
            this.$toastInfo(data.message);
          });
    },
    getVehicleTypes() {
      this.$http.get(ROUTES.DASHBOARD.GET_VEHICLE_TYPES).then(({data}) => {
        if (data.code > 0) {
          this.vehicleTypes = data.info;
          return;
        }
        this.$toastError(data.message);
      });
    },
    getTariffList() {
      this.$http
          .get(ROUTES.DASHBOARD.RATES.GET_RATES, {
            params: {
              companyId: this.company,
            }
          })
          .then(({data}) => {
            this.tariffList = data.code > 0 ? data.info : [];
          });
    },
    getCompanies() {
      this.isLoading = true;
      this.$http
          .get(ROUTES.DASHBOARD.GET_COMPANIES_TREE_V1)
          .then(({data}) => {
            if (data.code > 0) {
              this.companies = data.info;
              this.processData(this.companies);
            }
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
    processData(companies) {
      for (let index = 0; index < companies.length; index++) {
        let company = companies[index];
        company.label = company.name;
        company.id = company.code;
        if (company.children) {
          this.processData(company.children);
        }
      }
    },
  },
};
</script>
